export const errorsMessage = {
  451: 'token invalido',
};
